(() => {
    const activateConfigurator = configuratorID => {
        let data;
        let activeProducts = [];
        let askedQuestions = [];
        let answeredQuestions = [];
        let q = 0;
        let questionPublic = 0;
        let scriptedhashchange = false;
        
        const questiontemp = '<h2><!--<span class="numberdot">{{index}}</span> -->{{title}}</h2>{{description}}<div class="options">{{answersHTML}}</div>{{detailsmobile}}';
        const answeroptiontemp = '<label><input type="radio" name="question{{questionindex}}" value="{{label}}" {{checked}} /> {{label}}</label>';
        const imagelinktemp = '<span class="btn configmobileonly seelight"><span class="icon image"></span> Click to see illustrations</span>';
        const detailslinktemp = '<span class="btn configmobileonly seelight"> Click for more details</span>';
        const detailstemp = '<div class="panel"><h2>{{title}}</h2></div><p>{{description}}</p>{{image}}';
        const buttontemp = '<span class="btn {{class}}">{{label}}</span>';
        const ca = qs('#configActions');
        const qc = qs('#questioncontent');
        const qd = qs('#questiondetails');
        
        const setDefaultConfiguratorInteractions = () => {
            fe(qa('.radioLinks > a'), (a) => {
                a.addEventListener('click',() => {
                    const ahref = a.href;
                    const targetid = ahref.substring(ahref.indexOf('#'), ahref.length);
                    const t = qs('input' + targetid);
                    if(t) {
                        t.checked = true;
                        fe(qa('.seeoptions'), s => {
                            if(s.offsetHeight > 0) {
                                s.click();
                            }
                        });
                        return false;
                    }
                })
            });

            fe(qa('.seeoptions'), s => {
                s.addEventListener('click',() => {
                    const ls = s.closest('.light_section');
                    ls.classList.remove('configOptActive');
                    fadeOut(ls,null,() => {
                        const oh = qs('.dark_section .optionHolder', ls.parentNode);
                        oh.classList.add('configOptActive');
                        fadeIn(oh);
                    });
                });
            });

            fe(qa('.seelight'), s => {
                s.addEventListener('click', () => {
                    const oh = s.closest('.optionHolder');
                    oh.classList.remove('configOptActive');
                    fadeOut(oh, null, () => {
                        const ls = qs('.light_section',oh.closest('.dark_section').parentNode);
                        ls.classList.add('configOptActive');
                        fadeIn(ls);
                    });
                });
            });

            let checkedoptions = 0
            fe(qa('.options input'), s => {
                s.addEventListener('change', () => {
                    if(s.checked) {
                        checkedoptions++;
                    } else {
                        checkedoptions--;
                    }
                    let nextbtn = qs('#configActions .next');
                    if(nextbtn) {
                        if(checkedoptions > 0) {
                            nextbtn.textContent = 'Next';
                            nextbtn.classList.add('lbtn')
                            nextbtn.classList.remove('dbtn');
                        } else {
                            nextbtn.textContent = 'Skip';
                            nextbtn.classList.remove('lbtn');
                            nextbtn.classList.add('dbtn');
                        }
                    }
                });
            });

            let qtyOpts = qa('.optqty input');
            fe(qtyOpts, n => {
                n.addEventListener('change', () => {
                    let total = 0;
                    fe(qtyOpts, inp => {
                        total += parseInt(inp.value);
                    });
                    let nextbtn = qs('#configActions .next')
                    if(total > 0) {
                        nextbtn.textContent = 'Next';
                        nextbtn.classList.add('lbtn');
                        nextbtn.classList.remove('dbtn');
                    } else {
                        nextbtn.textContent = 'Skip';
                        nextbtn.classList.remove('lbtn');
                        nextbtn.classList.add('dbtn');
                    }
                });
            })
        };
        
        const displayQuestion = () => {
            if(q < data.questions.length) {
                const currentQuestion = data.questions[q];
                const answers = currentQuestion.answers.filter(a => {
                    return activeProducts[q].filter(b => {
                        return a.product_id == b.product_id; 
                    }).length > 0;
                });
                let uniqueAnswers = [];
                fe(answers, (a,i) => {
                    if(uniqueAnswers.length == 0) {
                        uniqueAnswers.push({label:a.value,count:1, order_priority: a.order_priority});
                    } else {
                        const matchUA = uniqueAnswers.filter(b => {
                           return a.value == b.label;
                        });
                        if(matchUA.length == 0) {
                            uniqueAnswers.push({label:a.value,count:1, order_priority: a.order_priority});
                        } else {
                            matchUA[0].count++;
                        }
                    }
                });
                if(uniqueAnswers.length > 1) {
                    let answersHTML = "";
                    
                    uniqueAnswers = uniqueAnswers.sort((a,b) => {

                        const aOrderPriority = parseInt(a.order_priority, 10);
                        const bOrderPriority = parseInt(b.order_priority, 10);

                        if (aOrderPriority < bOrderPriority) {
                            return -1;
                        }
                        else if (aOrderPriority > bOrderPriority) {
                            return 1;
                        }
                        else {
                            const AInt = parseInt(a.label);
                            const BInt = parseInt(b.label);
                            if(isNaN(AInt) && isNaN(BInt)){
                                if(a.label < b.label)
                                    return -1;
                                else if(a.label > b.label)
                                    return 1;
                                else 
                                    return 0;
                            } if(isNaN(AInt)){//A is not an Int
                                return 1;//to make alphanumeric sort first return -1 here
                            }else if(isNaN(BInt)){//B is not an Int
                                return -1;//to make alphanumeric sort first return 1 here
                            }else{
                                return AInt > BInt ? 1 : -1;
                            }
                            return 0;
                        } 
                    });
                    
                    for(let i = 0; i < uniqueAnswers.length; i++) {
                        let ua = uniqueAnswers[i];
                        let checked = "";
                        if(answeredQuestions[q]) {
                            if(answeredQuestions[q].indexOf(ua.label) > -1) {
                                checked = "checked";
                            }
                        }
                        answersHTML += applyTemplate(answeroptiontemp,{questionindex:q, label:ua.label, checked:checked });
                    }
                    askedQuestions.push(q);
                    questionPublic++; 
                    
                    const details = { title:currentQuestion.question, description:currentQuestion.description, image:'' };
                    let detailsHTML = detailslinktemp;
                    if(typeof currentQuestion.image == "string") {
                        details.image = `<img src="/images/configurators/${currentQuestion.image}" alt="${currentQuestion.description}" />`;
                        detailsHTML = imagelinktemp;
                    }
                    let qdesc = "";
                    const textTest = document.createElement('div');
                    textTest.innerHTML = currentQuestion.description;
                    if(typeof currentQuestion.description == "string" && textTest.textContent.trim() != "") {
                        qdesc = `<p>${qdesc}</p>`;
                    }
                    
                    qd.innerHTML = applyTemplate(detailstemp,details);
                    qc.innerHTML = applyTemplate(questiontemp,{ index:questionPublic, title:currentQuestion.question, description:qdesc, answersHTML:answersHTML, detailsmobile:detailsHTML});
                    ca.innerHTML = '';
                    
                    fe(qa('input[type="radio"]',qc), i => {
                        i.addEventListener('change',saveAnswers);
                    });
                    
                    let nextbtn = document.createElement('div');
                    nextbtn.innerHTML = applyTemplate(buttontemp,{ 'class':'lbtn next', 'label':'Next'});
                    nextbtn = nextbtn.firstChild;
                    nextbtn.addEventListener('click',saveAnswers);
                    ca.appendChild(nextbtn);
                    
                    if(q > 0) {
                        let backbtn = document.createElement('div');
                        backbtn.innerHTML = applyTemplate(buttontemp,{ 'class':'dbtn back', 'label':'Go Back'});
                        backbtn = backbtn.firstChild;
                        backbtn.addEventListener('click',returnLastQuestion);
                        ca.appendChild(backbtn);
                    } else {
                        const f = document.createElement('form');
                        f.action = "/products/url_path_ref.php";
                        f.method = "get";
                        const data = new URLSearchParams(window.location.search);
                        let val = '';
                        if(data.get('code')) {
                            val = data.get('code');
                        }
                        f.innerHTML = `<input name="ref" placeholder="Enter Code" id="configrestorecode" value="${val}" /><button type="submit" class="btn dbtn">Load configuration</button>`;
                        ca.appendChild(f);
                    }
                    
                    
                    fadeIn(ca);
                    fadeIn(qc);
                    fadeIn(qd);
                    setDefaultConfiguratorInteractions();
                } else {
                    activeProducts[q+1] = activeProducts[q];
                    if(q < data.questions.length) {
                        q++;
                        displayQuestion();
                    } else {
                        questionPublic++;
                        q++;
                        getProduct(activeProducts[q+1]);
                    }
                }
            } else {
                if(activeProducts[activeProducts.length-1].length) {
                    getProduct(activeProducts[activeProducts.length-1][0]);
                } else {
                    getProduct(activeProducts[activeProducts.length-1]);
                }
            }
        };
        
        let saving = false;
        const saveAnswers = () => {
            if(!saving && !returning) {
                const c = qa('input:checked',qc);
                if(c.length > 0) {
                    saving = true;
                    const selectedValues = [];
                    fe(c,s => {
                        selectedValues.push(s.value);
                    });
                    answeredQuestions[q] = selectedValues;
                    const product_ids = [];
                    fe(data.questions[q].answers,(a,i) => {
                        if(selectedValues.indexOf(a.value) > -1) {
                            product_ids.push(a.product_id); 
                        }
                    });
                    const matchingProducts = activeProducts[q].filter(a => product_ids.indexOf(a.product_id) > -1);
                    const answerArr = [];
                    for(let ans in answeredQuestions) {
                        answerArr.push(ans + "~" + answeredQuestions[ans].join('_'));
                    }
                    scriptedhashchange = true;
                    location.hash = 'answers=' + answerArr.join(',');
                    q++;
                    if(q < data.questions.length && matchingProducts.length > 1) {
                        activeProducts[q] = matchingProducts;
                        fadeOut(qd);
                        fadeOut(qc)
                        fadeOut(ca,null,() => {
                            saving = false;
                            displayQuestion();
                        });
                    } else {
                        questionPublic++;
                        saving = false;
                        getProduct(matchingProducts[0]);
                    }
                } else {
                    alert('please select and option');
                }
            }
        }
        
        let returning = false;
        const returnLastQuestion = () => {
            if(!returning && !saving) {
                returning = true;
                fadeOut(qd);
                fadeOut(qc);
                fadeOut(ca, null, () => {
                    returning = false;
                    questionPublic-=2;
                    askedQuestions.pop()
                    q = askedQuestions.pop();
                    displayQuestion();
                });
            }
        }
        
        let o = 0;
        let selProductOpts;
        let selProductAcce;
        let lastSelectedProduct;
        let productOptsSelected = {};
        const getProduct = product => {
            if(typeof product != 'undefined') {
                if(lastSelectedProduct != product) {
                    fetch(`/products/accessories.php?id=${product.product_id}&options=1`)
                    .then(res => res.json())
                    .then(optdata => {
                        o = 0;
                        lastSelectedProduct = product;
                        productOptsSelected = {};
                        selProductOpts = optdata.options;
                        selProductAcce = optdata.accessories;
                        
                        const h = location.hash.replace('#','');
                        const optstring = h.match('options=([^;&]+)');
                        if(optstring || h.match('summary=([^;&]+)')) {
                            getProductOptionsFromHash();
                        }
                        
                        fadeOut(qd);
                        fadeOut(qc);
                        fadeOut(ca, null, () => {
                            displayProductOption();
                        });
                        try {
                            cabox.closeBox();
                        } catch(e) {};
                    })

                    try {
                        cabox.showLoader();
                    } catch(e) {};
                } else {
                    fadeOut(qd);
                    fadeOut(qc);
                    fadeOut(ca, null, () => {
                        displayProductOption();
                    });
                }
            }
        }
        
        const getProductFromChildren = (children, optid) => {
            if(children.length > 0) {
                for(let i = 0;i < children.length;i++) {
                    const proddetail = children[i].options.filter(a => a.id == optid);
                    if(proddetail.length > 0) {
                        return proddetail[0];
                        break;
                    } else if(children[i].children.length > 0) {
                        return getProductFromChildren(children[i].children, optid);
                    }
                }
                return false;
            }
            return false;
        }
        
        const getProductOptionsFromHash = () => {
            const h = location.hash.replace('#','');
            const optstring = h.match('options=([^;&]+)');
            if(optstring) {
                const grouparr = unescape(optstring[1]).split('_');
                let maxGroup = 0;
                const ungroupedOpt = selProductOpts.ungrouped.length > 0?1:0;
                for(let i = 0; i < grouparr.length; i++) {
                    let groupanswers = grouparr[i].split(',');
                    for(let j = 0; j < groupanswers.length; j++) {
                        if(groupanswers[j].indexOf('.') > -1) {
                            let optvars = groupanswers[j].split('.');
                            if(optvars.length > 2) {
                                let groupid = optvars[0];
                                maxGroup = Math.max(groupid, maxGroup);
                                let optid = optvars[1];
                                let optionvalue = optvars[2];
                                let proddetail;
                                if(groupid < selProductOpts.groups.length) {
                                    proddetail = selProductOpts.groups[groupid];
                                    if(proddetail.options) {
                                        proddetail = proddetail.options.filter(a => a.id == optid);
                                        if(proddetail.length > 0) {
                                            proddetail = proddetail[0];
                                        } else {
                                            proddetail = getProductFromChildren(selProductOpts.groups[groupid].children, optid);
                                        }
                                    }
                                } else if(groupid == selProductOpts.groups.length && selProductOpts.ungrouped.length > 0) {
                                    let prodgroup = selProductOpts.ungrouped;
                                    proddetail = prodgroup.filter(a =>  a.id == optid);
                                    if(proddetail.length > 0) {
                                        proddetail = proddetail[0];
                                    }
                                } else if(groupid >= selProductOpts.groups.length) {
                                    let product = selProductAcce.products.find(p => p.product_id == optid)
                                    product.quantity = optionvalue;
                                    if(!productOptsSelected[groupid] ) {
                                        productOptsSelected[groupid] = {}
                                    }
                                    productOptsSelected[groupid][optid] = { 
                                        name:product.product_name, 
                                        val: optionvalue, 
                                        quantity: optionvalue,
                                        group:o,
                                        image_url:product.primary_image.large_thumb_url,
                                        thumb_image_url:product.primary_image.medium_thumb_url,
                                        price:product.product_price,
                                        incvatprice:product.product_price_incvat,
                                        accessory:true
                                    };
                                }
                                
                                if(proddetail) {
                                    if(!productOptsSelected[groupid]) {
                                        productOptsSelected[groupid] = {}
                                    }
                                    let selValDetail;
                                    if(proddetail.options) {
                                        selValDetail = proddetail.options.filter(a => a.id == optionvalue)
                                    } else {
                                        selValDetail = proddetail.values.filter(a => a.id == optionvalue)
                                    }
                                    if(selValDetail && selValDetail.length > 0) {
                                        selValDetail = selValDetail[0];
                                    }
                                    productOptsSelected[groupid][optid] = { val: optionvalue, group:groupid };
                                    
                                    if(proddetail.values && proddetail.values.length == 1) {
                                        productOptsSelected[groupid][optid].name = proddetail.name;
                                    } else {
                                        productOptsSelected[groupid][optid].name = selValDetail.name;
                                    }
                                    if(selValDetail.image_url) {
                                        productOptsSelected[groupid][optid].image_url = selValDetail.image_url;
                                        productOptsSelected[groupid][optid].thumb_image_url = selValDetail.thumb_image_url;
                                    }
                                    if(selValDetail.price) {
                                        productOptsSelected[groupid][optid].price = selValDetail.price;
                                        productOptsSelected[groupid][optid].incvatprice = selValDetail.price_incvat;
                                    }
                                    if(optvars.length > 3) {
                                       productOptsSelected[groupid][optid].quantity = optvars[3];
                                    }
                                }
                            }
                        }
                    }
                }
                o = maxGroup+1;
            }
            const summarystring = h.match('summary=([^;&]+)');
            if(summarystring) {
                let end = selProductOpts.groups.length + (selProductOpts.ungrouped.length > 0?1:0)
                if(selProductAcce.groups) {
                    end += selProductAcce.groups.length + (selProductAcce.ungrouped.length > 0?1:0);
                }
                o = end;
            }
        }
        
        const displayProductOption = () => {
            let g;
            const ungroupedopts = selProductOpts.ungrouped.length > 0?1:0;
            const ungroupedacce = selProductAcce.ungrouped.length > 0?1:0;
            if(o < selProductOpts.groups.length + ungroupedopts) {
                if(o == selProductOpts.groups.length) {
                    g = selProductOpts.ungrouped;
                    displayOptions(g);
                } else {
                    g = selProductOpts.groups[o];
                    displayOptions(g);
                } 
            } else if(o - (selProductOpts.groups.length + ungroupedopts) < selProductAcce.groups.length + ungroupedacce) {
                if(o - (selProductOpts.groups.length + ungroupedopts) == selProductAcce.groups.length && ungroupedacce > 0) {
                    displayAccessories({name:'Other Accessories',products:selProductAcce.ungrouped})
                } else {
                    displayAccessories(selProductAcce.groups[o - (selProductOpts.groups.length + ungroupedopts)])
                }
            } else {
                scriptedhashchange = true;
                location.hash = location.hash.replace(';summary=1','') + ";summary=1";
                displaySummary();
            }
        }
        
        const getOptionsHTML = opt => {
            let options = "";
            let imageshtml = "";
            if(opt.options) {
                opt.options.forEach(o => {
                    if(o.values.length > 1) {
                        options += `<h3>${o.name}${(opt.required?"*":"")}</h3>`;
                    } else {
                        if(o.multiselect) {
                            options += "<h3>";
                        } else {
                            options += "<h3><label>";
                        }
                    }
                    const ghtml = getValuesHTML(o);
                    imageshtml += ghtml.images;
                    options += ghtml.options;
                    if(o.values.length == 1) {
                        /*let price = "";
                        if(this.values[0].price) {
                            price = " (&pound;"+this.values[0].price+")";
                        }*/
                        if(o.multiselect) {
                            options += "</h3>";
                        } else {
                            options += ` ${o.name}${(opt.required?"*":"")}</label></h3>`;
                        }
                    }
                });
            } else {
                let ghtml = getValuesHTML(opt);
                imageshtml += ghtml.images;
                options += ghtml.options;
            }
            return {options:options, imageshtml:imageshtml};
        }
        
        
        const displayOptions = opt => {
            let imageshtml = "";
            let optionsDisplay = "";
            let options = "";
            let solo = false;
            
            const od = getOptionsHTML(opt);
            options += od.options;
            imageshtml += od.imageshtml;
            
            if(opt.children.length > 0) {
                for(let i = 0; i < opt.children.length; i++) {
                    if(opt.children[i].options.length > 0) {
                        options += `<div class='configexp__subgroup'><h3>${opt.children[i].name}</h3>${opt.children[i].description}${getOptionsHTML(opt.children[i]).options}</div>`;
                    }
                }
            }
            
            if(typeof opt.name == "string") {
                optionsDisplay += `<h2>${opt.name}${(!opt.required?"":"*")}</h2>`;
            } else {
                optionsDisplay += "<h2>Optional Extras</h2>";
            }
            if(solo) {
                optionsDisplay += `<label>${options} ${opt.name}${(opt.required?"*":"")}</label>`;
            } else {
                optionsDisplay += `<div class='options'>${options}</div>`;
            }
            
            if(imageshtml != "") {
                imageshtml = `<div class="panel"><span class="pointarrow"></span><h2>Refine Your Product</h2></div>${imageshtml}`;
                optionsDisplay += imagelinktemp;
            }
            qc.innerHTML = optionsDisplay;
            fadeIn(qc);
            qd.innerHTML = imageshtml;
            fadeIn(qd);
            
            let backbtn = document.createElement('div');
            backbtn.innerHTML = applyTemplate(buttontemp,{ 'class':'dbtn back', 'label':'Go Back'});
            backbtn = backbtn.firstChild;
            if(o == 0) {
                backbtn.addEventListener('click', () => {
                    if(askedQuestions[askedQuestions.length-1] != 'Product') {
                        askedQuestions.push('Product');
                    }
                    returnLastQuestion();
                });
            } else {
                backbtn.addEventListener('click', returnLastOptionGroup);
            }
            let nextbtn = document.createElement('div');
            nextbtn.innerHTML = applyTemplate(buttontemp,{ 'class':'dbtn next', 'label':'Skip'});
            nextbtn = nextbtn.firstChild;
            nextbtn.addEventListener('click', nextOptions);
            
            const radios = qa('input[type="radio"]',qc);
            if(radios.length > 0 && qa('input:not([type="radio"])',qc).length == 0) {
                const firstName = radios[0].name;
                if(radios.length == ap.filter.call(radios,r => r.name == firstName).length) {
                    fe(radios, r => {
                        r.addEventListener('click',nextOptions);
                    });
                }
            }
            
            ca.innerHTML = '';
            ca.appendChild(nextbtn);
            ca.appendChild(backbtn);
            fadeIn(ca);
            setDefaultConfiguratorInteractions();
        }
        
        const getAccessoriesHTML = acc => {
            let accessories = "";
            let imageshtml = "";
            if(acc.products) {
                acc.products.forEach(o => {
                    const product = selProductAcce.products.find(p => p.product_id == o)
                    accessories += `<h3 class="npb">${product.product_name}</h3><div class="inlineblock"><div class="exvat"><strong>£${product.product_price}</strong><span class="small">ex. VAT</span></div><div class="incvat"><strong><span class="colour">£${product.product_price_incvat}</span></strong><span class="small">inc. VAT</span></div></div><div class='optqty'>Q<span class='sshide'>uanti</span>ty <span class="incrementor"><input type='number' data-productid='${product.product_id}' name='accessory[${product.product_id}][0][quantity]' placeholder='Qty' class='fr' value='${product.quantity?product.quantity:0}' min='0' /></span></div>`;
                    imageshtml += `<span class='optimg radioLinks'><a href='#acc${product.product_id}' onclick='return false'><span class='optimgnode'><span class='overimage'><img src='${product.primary_image.large_thumb_url}' alt='${product.product_name}' /></span><img src='${product.primary_image.medium_thumb_url}' alt='${product.product_name}' /></span>${product.product_name}</a></span>`;;
                });
            }
            return {accessories:accessories, imageshtml:imageshtml};
        }

        const displayAccessories = acce => {
            let imageshtml = "";
            let accessoryDisplay = "";
            let accessories = "";
            let solo = false;
            
            const od = getAccessoriesHTML(acce);
            accessories += od.accessories;
            imageshtml += od.imageshtml;
            
            if(typeof acce.name == "string") {
                accessoryDisplay += `<h2>${acce.name}</h2>`;
            } else {
                accessoryDisplay += "<h2>Other Accessories</h2>";
            }
            if(acce.products.length == 1) {
                accessoryDisplay += `<label>${accessories}</label>`;
            } else {
                accessoryDisplay += accessories;
            }
            
            if(imageshtml != "") {
                imageshtml = `<div class="panel"><span class="pointarrow"></span><h2>Refine Your Product</h2></div>${imageshtml}`;
                accessoryDisplay += imagelinktemp;
            }
            qc.innerHTML = accessoryDisplay;
            fadeIn(qc);
            qd.innerHTML = imageshtml;
            window.setupIncrementors('#questioncontent');
            fadeIn(qd);
            
            let backbtn = document.createElement('div');
            backbtn.innerHTML = applyTemplate(buttontemp,{ 'class':'dbtn back', 'label':'Go Back'});
            backbtn = backbtn.firstChild;
            if(o == 0) {
                backbtn.addEventListener('click', () => {
                    if(askedQuestions[askedQuestions.length-1] != 'Product') {
                        askedQuestions.push('Product');
                    }
                    returnLastQuestion();
                });
            } else {
                backbtn.addEventListener('click', returnLastOptionGroup);
            }
            let nextbtn = document.createElement('div');
            nextbtn.innerHTML = applyTemplate(buttontemp,{ 'class':'dbtn next', 'label':'Skip'});
            nextbtn = nextbtn.firstChild;
            nextbtn.addEventListener('click', nextAccessories);
            
            ca.innerHTML = '';
            ca.appendChild(nextbtn);
            ca.appendChild(backbtn);
            fadeIn(ca);
            setDefaultConfiguratorInteractions();
        }
        
        const prodOptSelExists = oid => {
            return typeof productOptsSelected[o] == 'object' && typeof productOptsSelected[o][oid] == 'object';
        }
        
        const getValuesHTML = opt => {
            if(typeof opt.id == 'number') {
                return getOptionFromObj(opt);
            } else {
                let imageshtml = "";
                let options = "";
                for(let i = 0; i < opt.length; i++) {
                    let optobj = getOptionFromObj(opt[i]);
                    imageshtml += optobj.images;
                    if(opt[i].multiselect) {
                        options += `<h3>${opt[i].name}</h3>${optobj.options}`;
                    } else {
                        if(opt[i].values.length == 1) {
                            /*var price = "";
                            if(opt[i].values[0].price) {
                                price = " (&pound;" + currencyPad(opt[i].values[0].price) + ")";
                            }*/
                            options += `<h3><label>${optobj.options}${opt[i].name}</label></h3>`;
                        } else {
                            options += `<h3>${opt[i].name}</h3><label>${optobj.options}</label>`;
                        }
                    }
                    if(i+1 != opt.length) {
                        options += "<div class='clearspace'></div>";
                    }
                }
                return { options:options, images:imageshtml };
            }
        }
        
        const getOptionFromObj = opt => {
            let imageshtml = "";
            let options = "";
            if(opt.multiselect) {
                let val = 1;
                if(prodOptSelExists(opt.id)) {
                    val = productOptsSelected[o][opt.id].quantity;
                }
                options += `<div class='optqty'>Q<span class='sshide'>uanti</span>ty <input type='number' name='option[${opt.id}][0][quantity]' placeholder='Qty' value='${val}' min='1' /></div>`;
            }
            let activeid = "";
            if(opt.values && opt.values.length > 1) {
                if(prodOptSelExists(opt.id)) {
                    activeid = productOptsSelected[o][opt.id].val;
                }
                let checked = "";
                if(!opt.required)  {
                    if(activeid == "") {
                        checked = "checked='checked'";
                    }
                    options += `<label><input type='radio' name='option[${opt.id}][0][id]' data-name='' data-incvatprice='0' data-price='0' value='' ${checked} /> No Thanks</label>`; 
                }
                
                opt.values.forEach(a => {
                    let dataimage = "";
                    checked = ""
                    if(activeid == a.id) {
                        checked = "checked='checked'";
                    }
                    if(typeof a.image_url == "string" && a.image_url != "") {
                        imageshtml += `<span class='optimg radioLinks'><a href='#opt${opt.id+a.id}' onclick='return false'><span class='optimgnode'><span class='overimage'><img src='${a.image_url}' alt='${a.name}' /></span><img src='${a.thumb_image_url}' alt='${a.name}' /></span>${a.name}</a></span>`;
                        dataimage = `data-image='${a.image_url}'`;
                    }
                    
                    /*let price = "";if(this.price) { 
                        price = " (&pound;"+currencyPad(this.price)+")";
                    }*/
                    if(a.multiselect) {
                        let val = 1;
                        if(prodOptSelExists(opt.id)) {
                            val = productOptsSelected[o][opt.id].quantity
                        }
                        options += `<div class='optqty'>Q<span class='sshide'>uanti</span>ty <input type='number' name='option[${opt.id}][0][quantity]' placeholder='Qty' class='fr' value='${val}' min='1' /></div>`;
                    }
                    options += `<label><input type='radio' id='opt${opt.id+a.id}' name='option[${opt.id}][0][id]' data-name='${a.name}' data-incvatprice='${a.price_incvat}' data-price='${a.price}' value='${a.id}' ${dataimage} ${checked} /> ${a.name}</label>`;
                });
            } else {
                let dataimage = "";
                if(typeof opt.values[0].image_url == "string" && opt.values[0].image_url != "") {
                    imageshtml += `<span class='optimg radioLinks'><a href='#opt${opt.id+opt.values[0].id}' onclick='return false'><span class='optimgnode'><span class='overimage'><img src='${opt.values[0].image_url}' alt='${opt.values[0].name}' /></span><img src='${opt.values[0].thumb_image_url}' alt='${opt.name}' /></span>${opt.name}</a></span>`;
                    dataimage = `data-image='${opt.values[0].image_url}'`;
                }
                let checked = "";
                if(prodOptSelExists(opt.id)) {
                    activeid = productOptsSelected[o][opt.id].val;
                }
                if(activeid == opt.values[0].id) {
                    checked = "checked='checked'";
                }
                let opthtml = `<input type='checkbox' name='option[${opt.id}][0][id]' id='opt${opt.id+opt.values[0].id}' data-name='${opt.name}' data-incvatprice='${opt.values[0].price_incvat}' data-price='${opt.values[0].price}' value='${opt.values[0].id}' ${dataimage} ${checked} />`;
                if(opt.multiselect) {
                    /*let price = "";
                    if(opt.values[0].price) {
                        price = " (&pound;"+currencyPad(opt.values[0].price)+")";
                    }*/
                    opthtml = `<label class='multiselect'>${opthtml}${opt.values[0].name}</label>`;
                }
                options += opthtml;
            }
            return { options:options, images:imageshtml };
        }
        
        const nextOptions = () => {
            if(!returning && !saving) {
                fe(qa('.optqty input',qc), inp => {
                    inp.value = parseInt(inp.value);
                    if(inp.value < 1) {
                        inp.value = 1;
                    }
                });
                
                if(qa('input[type="radio"]:checked',qc).length > 0 || qa('input[type="radio"]',qc).length == 0) {
                    saving = true;
                    productOptsSelected[o] = {};
                    fe(qa('input:checked', qc), n => {
                        if(n.value != "") {
                            const optid = n.name.match(/option\[([^\]]+)\]\[0\]\[id\]/)[1];
                            productOptsSelected[o][optid] = { name:n.name, val: n.value, group:o };
                            if(ds(n,'name')) {
                                productOptsSelected[o][optid].name = ds(n,'name');
                            } 
                            if(ds(n,'image_url')) {
                                productOptsSelected[o][optid].image_url = ds(n,'image_url');
                            }
                            if(ds(n,'price')) {
                                productOptsSelected[o][optid].price = ds(n,'price');
                            }
                            if(ds(n,'incvatprice')) {
                                productOptsSelected[o][optid].incvatprice = ds(n,'incvatprice');
                            }
                            const qty = qs('input[name="option\['+optid+'\]\[0\]\[quantity\]"]');
                            if(qty) {
                               productOptsSelected[o][optid].quantity = qty.value;
                            }
                        }
                    });
                    
                    const h = location.hash.replace('#','');
                    
                    let prodString = "options=";
                    for(let p in productOptsSelected) {
                        let po = productOptsSelected[p];
                        if(prodString != "options=") {
                            prodString += "_";
                        }
                        let idsandquantity = [];
                        for(let p in po) {
                            let pstring = po[p].group + '.'
                            pstring += p + '.';
                            
                            pstring += po[p].val;
                            if(po[p].quantity) {
                                pstring += '.' + po[p].quantity;
                            }
                            idsandquantity.push(pstring);
                        }
                        prodString += idsandquantity.join(',');
                    }
                    
                    scriptedhashchange = true;
                    const ansstring = h.match('answers=([^;&]+)');
                    if(ansstring) {
                        let ansarr = ansstring[1];
                        location.hash = `answers=${ansarr};${prodString}`;
                    }
                    
                    fadeOut(qd);
                    fadeOut(qc);
                    fadeOut(ca,null, () => {
                        saving = false;
                        o++;
                        displayProductOption();
                    });
                    scrollToSel('#configurator');
                } else {
                    alert('Please select an option');
                }
            }
        }

        const nextAccessories = () => {
            if(!returning && !saving) {
                let addedaccessories = []
                fe(qa('.optqty input',qc), inp => {
                    const pid = ds(inp, 'productid');
                    let product = selProductAcce.products.find(p => p.product_id == pid);
                    product.quantity = inp.value;
                    if(inp.value > 0) {
                        addedaccessories.push({
                            name:product.product_name,
                            value:inp.value,
                            optid:pid,
                            image_url:product.primary_image.large_thumb_url,
                            thumb_image_url:product.primary_image.medium_thumb_url,
                            price:product.product_price,
                            incvatprice:product.product_price_incvat,
                            quantity:inp.value
                        })
                    }
                });
                
                if(addedaccessories.length > 0) {
                    saving = true;
                    productOptsSelected[o] = {};
                    fe(addedaccessories, n => {
                        const optid = n.optid;
                        productOptsSelected[o][optid] = { name:n.name, val: n.value, group:o };
                        if(n.name) {
                            productOptsSelected[o][optid].name = n.name;
                        } 
                        if(n.image_url) {
                            productOptsSelected[o][optid].image_url = n.image_url;
                            productOptsSelected[o][optid].thumb_image_url = n.thumb_image_url;
                        }
                        if(n.price) {
                            productOptsSelected[o][optid].price = n.price;
                        }
                        if(n.incvatprice) {
                            productOptsSelected[o][optid].incvatprice = n.incvatprice;
                        }
                        productOptsSelected[o][optid].val = n.quantity;
                        productOptsSelected[o][optid].quantity = n.quantity;
                        productOptsSelected[o][optid].accessory = true;
                    });
                    
                    const h = location.hash.replace('#','');
                    
                    let prodString = "options=";
                    for(let p in productOptsSelected) {
                        let po = productOptsSelected[p];
                        if(prodString != "options=") {
                            prodString += "_";
                        }
                        let idsandquantity = [];
                        for(let p in po) {
                            let pstring = po[p].group + '.'
                            pstring += p + '.';
                            
                            pstring += po[p].val;
                            if(po[p].quantity) {
                                pstring += '.' + po[p].quantity;
                            }
                            idsandquantity.push(pstring);
                        }
                        prodString += idsandquantity.join(',');
                    }
                    
                    scriptedhashchange = true;
                    const ansstring = h.match('answers=([^;&]+)');
                    if(ansstring) {
                        let ansarr = ansstring[1];
                        location.hash = `answers=${ansarr};${prodString}`;
                    }
                }
                    
                fadeOut(qd);
                fadeOut(qc);
                fadeOut(ca,null, () => {
                    saving = false;
                    o++;
                    displayProductOption();
                });
                scrollToSel('#configurator');
            }
        }
        
        const returnLastOptionGroup = () => {
            if(!returning && !saving) {
                returning = true;
                fadeOut(qd);
                fadeOut(qc);
                fadeOut(ca, null, () => {
                    returning = false;
                    o--;
                    displayProductOption();
                });
            }
        }
        
        const displaySummary = () => {
            let total = Number(lastSelectedProduct.product_price);
            let incvattotal = total * (1+Number(lastSelectedProduct.vat_rate_value));
            let formhtml = `<form method="post" action="/products/item.php" onsubmit="return gaAddToBasket(this)" id="basketform"><input type="hidden" name="action" value="add" /><input type="hidden" name="quantity" id="quantity" value="1" data-price="${total}" /><input type="hidden" name="product_id" value="${lastSelectedProduct.product_id}" /><input type="hidden" name="destination" value="basket" /><h2>Your Configured Product</h2><div class="configsummary"><span class="productPrice">${(total > 0?`<span class="exvat">&pound;${currencyPad(total)}</span><span class="incvat">&pound;${currencyPad(incvattotal)}</span>`:'POA')}</span><span class="productTitle">${lastSelectedProduct.product_name}</span></div>`;
            
            const proddata = {               
                'id': lastSelectedProduct.product_id,                   
                'name': lastSelectedProduct.product_name,
                'brand': lastSelectedProduct.manufacturer_name,
                'category': lastSelectedProduct.category_name
            };
            const referenceData = {
                id:configuratorID,
            }
            
            for(let ans in answeredQuestions) {
                for(let i = 0; i < answeredQuestions[ans].length; i++) {
                    referenceData["answers["+data.questions[ans].id+"]"] = answeredQuestions[ans][i];
                }
            }
            
            var imagehtml = '';
            if(lastSelectedProduct.primary_image) {
                imagehtml += `<span class='optimg'><span class='optimgnode'><span class='overimage'><img src='${lastSelectedProduct.primary_image[0].huge_thumb_url}' alt='${lastSelectedProduct.product_name}' /></span><img src='${lastSelectedProduct.primary_image[0].medium_thumb_url}' alt='${lastSelectedProduct.name}' /></span>${lastSelectedProduct.product_name}</span>`;
            }

            const ungroupedopts = selProductOpts.ungrouped.length > 0?1:0;
            const ungroupedacce = selProductAcce.ungrouped.length > 0?1:0;
            let accCount = -1;

            for(let i in productOptsSelected) {
                for(let n in productOptsSelected[i]){
                    let opt = productOptsSelected[i][n];
                    formhtml += `<div class='configsummary summaryitem' data-group='${opt.group}'>`

                    if(opt.accessory) {
                        accCount++;
                        formhtml += `<input type='hidden' name='accessory[${accCount}][id]' value='${n}' />`;
                        referenceData[`accessory[${accCount}][quantity]`] = opt.val;
                    } else {
                        formhtml += `<input type='hidden' name='option[${n}][0][id]' value='${opt.val}' />`;
                        referenceData[`options[${n}][option_value_id]`] = opt.val;
                        if(opt.quantity) {
                            referenceData[`options[${n}][quantity]`] = opt.quantity;
                        } 
                    }
                    if(opt.price && opt.price > 0) {
                        if(opt.quantity) {
                            formhtml += `<span class='productPrice'><span class='exvat'>&pound;${(currencyPad(opt.price * parseInt(opt.quantity)))}</span><span class='incvat'>&pound;${(currencyPad(opt.incvatprice * parseInt(opt.quantity)))}</span></span>`;
                            total += (Number(opt.price) * parseInt(opt.quantity));
                            incvattotal += (Number(opt.incvatprice) * parseInt(opt.quantity));
                        } else {
                            formhtml += `<span class='productPrice'><span class='exvat'>&pound;${currencyPad(opt.price)}</span><span class='incvat'>&pound;${currencyPad(opt.incvatprice)}</span></span>`;
                            total += Number(opt.price);
                            incvattotal += Number(opt.incvatprice);
                        }
                    } else {
                        formhtml += "POA";
                    }
                    if(typeof opt.image_url == "string" && opt.image_url != "") {
                        imagehtml += `<span class='optimg'><span class='optimgnode'><span class='overimage'><img src='${opt.image_url}' alt='${opt.name}' /></span><img src='${opt.thumb_image_url}' alt='${opt.name}' /></span>${opt.name}</span>`;
                    }
                    if(opt.accessory) {
                        formhtml += `<span class='productTitle'>${opt.name}</span><span class='productQty'><input type='hidden' name='accessory[${accCount}][quantity]' value='${opt.quantity}' />x${opt.quantity}</span>`;
                    } else {
                        formhtml += `<span class='productTitle'>${opt.name}<input type='hidden' name='option[${n}][0][quantity]' value='1' /></span>`;
                        if(opt.quantity) {
                            formhtml += `<span class='productQty'><input type='hidden' name='option[${n}][0][quantity]' value='${opt.quantity}' />x${opt.quantity}</span>`;
                        }
                    }
                    formhtml += "</div>";
                };
            };
            formhtml += `<br /><div class='right'><p><strong class='totalPrice'>${(total > 0?`Total: <span class='exvat'><span class='big'>&pound;${currencyPad(total)}</span><span class='vattag'>ex. VAT</span></span><span class='incvat'><span class='big'>&pound;${currencyPad(incvattotal)}</span><span class='vattag'>inc. VAT</span></span>`:"POA")}</strong></p>${(!lastSelectedProduct.product_poa?"<input type='submit' class='btn bbtn mainbtn' onclick='ga4a2b();' value='Add to basket' />":"POA = Price on application")} <button type='submit' name='destination' value='quote' id='quote_basket' onclick='ga4a2b();' class='btn pbtn'>Add to Quote</button></div></form>`;
            
            if(imagehtml != "") {
                formhtml += imagelinktemp;
            }
            
            qc.innerHTML = formhtml;
            fadeIn(qc);
            qd.innerHTML = imagehtml;
            fadeIn(qd);
            
            let backbtn = document.createElement('div');
            backbtn.innerHTML = applyTemplate(buttontemp,{ 'class':'dbtn back', 'label':'Go Back'});
            backbtn = backbtn.firstChild;
            if(o == 0) {
                backbtn.addEventListener('click',() => {
                    if(askedQuestions[askedQuestions.length-1] != 'Product') {
                        askedQuestions.push('Product');
                    }
                    returnLastQuestion();
                });
            } else {
                backbtn.addEventListener('click',returnLastOptionGroup);
            }
            ca.innerHTML = '<span id="refenceNumber"></span><div class="clear"></div>If you would like to complete the order for this product over the phone, please call 01539 760 650 and quote the reference above.';
            ca.firstChild.insertAdjacentElement('afterend', backbtn);
            fadeIn(ca);
            fe(qa('.summaryitem'),n => {
                n.addEventListener('click',() => {
                    o = parseInt(ds(m,'group'));
                    fadeOut(qd);
                    fadeOut(qc);
                    fadeOut(ca,null,() => {
                        displayProductOption();
                    });
                });
            });
            
            qs('#quote_basket').addEventListener('click',() => {
                var inp = document.createElement('input');
                inp.type = 'hidden';
                inp.name = 'destination';
                inp.value = 'Quote';
                qs('#basketform').appendChild(inp);
            });
            
            qs('.totalPrice').addEventListener('click',() => {
                if(document.body.className.indexOf('incvat') > -1) {
                    document.body.className = document.body.className.replace(new RegExp(' (ex|in)cvat(in)?','g'),'') + ' excvat';
                    document.cookie = 'cookievat=excvat;path=/';
                } else {
                    document.body.className = document.body.className.replace(new RegExp(' (ex|in)cvat(in)?','g'),'') + ' incvat';
                    document.cookie = 'cookievat=incvat;path=/';
                }
            });
            setDefaultConfiguratorInteractions();
            
            const locat = location.pathname + location.search + location.hash;
            fetch('/products/url_path_ref.php', {
                method:'POST', 
                headers: {"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"},
                body: `path=${locat}`
            })
            .then(res => res.json())
            .then(udata => {
                if(udata.success) {
                    qs('#refenceNumber').innerHTML = `Your Reference Code: <span class="refenceNumber">${udata.ref} </span>  <span class='referenceShare'><span class="icon-share icon" alt="Share"></span></span>`;

                    qs('.referenceShare').addEventListener('click', () => {
                        navigator.share({
                            url:`${location.protocol}//${location.host}${location.pathname}?code=${udata.ref}`,
                            title:data.title,
                            text:`My ${data.name} configuration`
                        });
                    });  
                }
            });
        }
        
        const loadPositionfromHash = () => {
            if(typeof data == 'object') {
                const h = location.hash.replace('#','');
                const ansstring = h.match('answers=([^;&]+)');
                if(ansstring) {
                    let ansarr = unescape(ansstring[1]).split(',');
                    let lastAns = 0;
                    let count = 0;
                    let matchingProducts = data.products;
                    for(var a in ansarr) {
                        let nlpair = ansarr[a].split('~');
                        let selectedValues = nlpair[1].split('_');
                        let product_ids = [];
                        fe(data.questions[nlpair[0]].answers,a => {
                            if(selectedValues.indexOf(a.value) > -1) {
                                product_ids.push(a.product_id); 
                            }
                        });
                        activeProducts[nlpair[0]] = matchingProducts;
                        
                        matchingProducts = activeProducts[nlpair[0]].filter(a => product_ids.indexOf(a.product_id) > -1);
                        
                        lastAns = parseInt(nlpair[0]);
                        
                        askedQuestions.push(lastAns);
                        answeredQuestions[lastAns] = selectedValues;
                        count++;
                    }
                    q = lastAns;
                    questionPublic = count;
                    if(matchingProducts.length == 1 || q >= data.questions.length -1) {
                        questionPublic++;
                        q++;
                        getProduct(matchingProducts[0]);
                    } else {
                        activeProducts[q+1] = matchingProducts;
                        q++;
                        displayQuestion();
                    }
                }
            }
        }
        
        const hashChanged = () => {
            if(!scriptedhashchange) {
                o = 0;
                q = 0;
                questionPublic = 0;
                lastSelectedProduct = null;
                productOptsSelected = {};
                askedQuestions = [];
                answeredQuestions = [];
                if(location.hash == "") {
                    displayQuestion();
                } else {
                    loadPositionfromHash();
                }
            }
            scriptedhashchange = false;
        }

        fetch(`/products/configurator_json.php?id=${configuratorID}`)
        .then(res => res.json())
        .then(jsdata => {
            data = jsdata.configurator;
            activeProducts[0] = data.products;
            if(location.hash && location.hash.indexOf('answers=') > -1) {
                loadPositionfromHash();
            } else {
                displayQuestion();
            }
        });
        
        if (window.addEventListener) {
            window.addEventListener("hashchange", hashChanged,false);
        } else if(window.attachEvent) {
            window.attachEvent("onhashchange", hashChanged);
        }
        
        window.addEventListener('resize',() => {
            const wwidth = getWWidth();
            if(typeof wwidth == 'number') {
                if(wwidth > 765) {
                    fe(qa('.optionHolder, .light_section'),s => {
                        s.style.display = '';
                    });
                } else {
                    fe(qa('.optionHolder, .light_section'),s => {
                        s.style.display = 'none';
                    });
                    fe(qa('.configOptActive'),s => {
                        s.style.display = '';
                    });
                }
            }
        });
    }

    const startConfigurator = () => {
        if(config_id) {
            activateConfigurator(config_id);
        }
    }

    if(scriptReady) {
        startConfigurator();
    } else {
        if (document.addEventListener) {
            document.addEventListener("scriptReady", startConfigurator, false);
        } else {
            document["onscriptReady"] = startConfigurator
        }
    }
})();

let proddata;